import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-feedback-widget',
  templateUrl: './feedback-widget.component.html',
  styleUrls: ['./feedback-widget.component.scss'],
  standalone: false
})
export class FeedbackWidgetComponent {

  @Input() title!: string;
  @Input() text!: string;
  @Input() score!: number;
  @Input() color?: 'success' | 'warn' | 'error';

  constructor() {}

  ngOnInit() {
  }
}
